export const LIMIT = 25;
export const TRADEDESK_SECTIONS = ['details'];
